const AccountType = {
  USER: "USER",
  SUPER_ADMIN: "SUPER_ADMIN",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
};

const AccountPath = {
  USER: "/user/",
  SUPER_ADMIN: "/super-admin/",
  SYSTEM_ADMIN: "/system-admin/",
};

export { AccountType, AccountPath };
